import * as types from './mutations-types'

export default {
  [types.SET_USER](state, user) {
    state.user = Object.assign({}, user)

    state.user.type = 2
  },
  [types.SET_USER_EMAIL](state, email) {
    if (!state.user) {
      state.user = {
        type: 2
      }
    }
    state.user.email = email
  },
  [types.SET_USER_ID](state, id) {
    if (!state.user) {
      state.user = {
        type: 2
      }
    }

    state.user.id = id
  },
  [types.SET_ONLINE_AGENTS](state, onlineAgents) {
    state.onlineAgents = onlineAgents
  }
}
